var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFxbetLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 118.912 40.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs993"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4",
    "data-name": "Namnl\\xF6s \\xF6vertoning 4",
    x1: 64.837,
    y1: 13.028,
    x2: 64.837,
    y2: 29.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29abe2",
    id: "stop984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b5eab",
    id: "stop986"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4-2",
    x1: 86.916,
    y1: 13.028,
    x2: 86.916,
    y2: 29.748,
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4-3",
    x1: 108.369,
    y1: 13.028,
    x2: 108.369,
    y2: 29.748,
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4-4",
    x1: 9.258,
    y1: 13.028,
    x2: 9.258,
    y2: 29.748,
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Namnl\\xF6s_\\xF6vertoning_4-5",
    x1: 34.771,
    y1: 13.028,
    x2: 34.771,
    y2: 29.748,
    xlinkHref: "#Namnl\\xF6s_\\xF6vertoning_4"
  }), /*#__PURE__*/React.createElement("style", {
    id: "style982"
  }, ".cls-5{fill:url(#Namnl\xF6s_\xF6vertoning_4-5)}"))), /*#__PURE__*/React.createElement("g", {
    id: "g1013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1001"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.354 36.154V6.892h8.015a50.24 50.24 0 0 1 6.926.32 10.502 10.502 0 0 1 3.388 1.1 6.229 6.229 0 0 1 2.468 2.408 6.99 6.99 0 0 1 .85 3.488 5.862 5.862 0 0 1-1.27 3.967 7.995 7.995 0 0 1-4.047 2.229 7.002 7.002 0 0 1 4.877 2.189 7.478 7.478 0 0 1 1.759 5.206 8.33 8.33 0 0 1-.99 4.117 6.839 6.839 0 0 1-2.828 2.759 11.624 11.624 0 0 1-3.697 1.139 53.033 53.033 0 0 1-7.196.34Zm7.396-17.57h1.599a8.754 8.754 0 0 0 4.058-.65 2.396 2.396 0 0 0 1.099-2.248 2.565 2.565 0 0 0-1.03-2.328 8.129 8.129 0 0 0-4.007-.67H60.75Zm0 11.593h2.798a8.272 8.272 0 0 0 4.018-.71 2.544 2.544 0 0 0 1.179-2.368 2.875 2.875 0 0 0-1.08-2.568 7.688 7.688 0 0 0-3.997-.73H60.75Z",
    id: "path995",
    style: {
      fill: "url(#Namnl\xF6s_\xF6vertoning_4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.952 36.154V6.892h17.929v6.416H85.727v5.077h9.574v6.276h-9.574v4.937h10.154v6.556Z",
    id: "path997",
    style: {
      fill: "url(#Namnl\xF6s_\xF6vertoning_4-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.381 36.154V13.808h-6.556V6.892h21.087v6.916h-6.556v22.346Z",
    id: "path999",
    style: {
      fill: "url(#Namnl\xF6s_\xF6vertoning_4-3)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.154V6.892h18.515v6.416H7.775v5.077h9.574v6.276H7.775v11.493Z",
    id: "path1003",
    style: {
      fill: "url(#Namnl\xF6s_\xF6vertoning_4-4)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1011"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    id: "polygon1005",
    d: "M55.118 9.592 45.526 0 34.781 10.745l9.481.075-9.491 9.492-9.491-9.492 9.481-.075L24.016 0l-9.592 9.592 10.755 10.755-10.755 10.755 9.592 9.592L34.74 29.97l-9.46-.075 9.491-9.492 9.491 9.492-9.46.075 10.724 10.724 9.592-9.592-10.755-10.755L55.118 9.592z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    id: "rect1007",
    d: "M34.765 10.741h.013v.013h-.013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    id: "polygon1009",
    d: "M34.74 29.97h.062l-.031-.031-.031.031z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxbetLogo);
export default __webpack_public_path__ + "static/media/fxbet-logo.39eb7779d3881367784584bc7ecefb4d.svg";
export { ForwardRef as ReactComponent };